import React from "react";
import { colors } from "core/styles/snippets";
export var ClosedAccountItem = function (_a) {
    var className = _a.className;
    return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M13.0051 15.9311H10.9973L5 9.93622L6.86513 8.06891L12 13.2038L17.1349 8.06891L19 9.93622L13.0051 15.9311Z", fill: colors.link })));
};
